import React from "react";
import Grid from "@mui/material/Grid";
import { Field } from "formik";
import { TextField } from "formik-mui";
import { mastersApi } from "../../../../services/MasterDataServices";
import FormikRemoteAutocompleteField from "./FormikRemoteAutocompleteField";
import DimensionsFields from "./DimensionsFields";

export default function MasterEntryExtraFields({ categoryId }) {
  const showMuseumType =
    categoryId === "museum_exhibition_types" || categoryId === "ticket_discounts";
  const showVisitorType = false; // Removed ticket_fees from master data
  const showFee = false; // Removed ticket_fees from master data
  const showDiscountFields = categoryId === "ticket_discounts";
  const showStorageRoom = categoryId === "csr_racks";
  const showOwnership = categoryId === "accession_nos";
  const showObjectGroup = categoryId === "object_sub_groups";
  const showDimensions = categoryId === "dimensions";
  const showMasterItemCategory = categoryId === "master_items";

  const loadMuseumTypes = React.useCallback((params) => mastersApi("museum_types", "get", null, params), []);
  const loadVisitorTypes = React.useCallback((params) => mastersApi("visitor_types", "get", null, params), []);
  const loadExhibitionTypes = React.useCallback((params) => mastersApi("museum_exhibition_types", "get", null, params), []);
  const loadStorageRooms = React.useCallback((params) => mastersApi("storage_rooms", "get", null, params), []);
  const loadOwnerships = React.useCallback((params) => mastersApi("ownerships", "get", null, params), []);
  const loadObjectGroups = React.useCallback((params) => mastersApi("object_groups", "get", null, params), []);
  // Removed loadTicketFees since ticket_fees is no longer in master data
  const loadCategories = React.useCallback((params) => mastersApi("categories", "get", null, params), []);
  const loadTicketTypes = React.useCallback((params) => mastersApi("ticket_fees", "get", null, params), []);

  if (
    !showMuseumType &&
    !showVisitorType &&
    !showFee &&
    !showDiscountFields &&
    !showStorageRoom &&
    !showOwnership &&
    !showObjectGroup &&
    !showDimensions &&
    !showMasterItemCategory
  ) {
    return null;
  }

  return (
    <>
      {showMuseumType && (
        <Grid item xs={12} sm={6}>
          <FormikRemoteAutocompleteField
            name={"museum_type_id"}
            label={"Museum Type"}
            loadOptions={loadMuseumTypes}
          />
        </Grid>
      )}

      {showStorageRoom && (
        <Grid item xs={12} sm={6}>
          <FormikRemoteAutocompleteField
            name={"storage_room_id"}
            label={"Storage Room"}
            loadOptions={loadStorageRooms}
          />
        </Grid>
      )}

      {showOwnership && (
        <Grid item xs={12} sm={6}>
          <FormikRemoteAutocompleteField
            name={"ownership_id"}
            label={"Ownership"}
            loadOptions={loadOwnerships}
          />
        </Grid>
      )}

      {showObjectGroup && (
        <Grid item xs={12} sm={6}>
          <FormikRemoteAutocompleteField
            name={"object_group_id"}
            label={"Object Group"}
            loadOptions={loadObjectGroups}
          />
        </Grid>
      )}

      {showMasterItemCategory && (
        <Grid item xs={12} sm={6}>
          <FormikRemoteAutocompleteField
            name={"category"}
            label={"Category"}
            loadOptions={loadCategories}
          />
        </Grid>
      )}

      {showDimensions && <DimensionsFields />}

      {showVisitorType && (
        <Grid item xs={12} sm={6}>
          <FormikRemoteAutocompleteField
            name={"visitor_type_id"}
            label={"Visitor Type"}
            loadOptions={loadVisitorTypes}
          />
        </Grid>
      )}

      {showFee && (
        <Grid item xs={12} sm={6}>
          <Field
            component={TextField}
            variant={"outlined"}
            size={"small"}
            fullWidth
            label={"Fee"}
            name={"fee"}
            type={"number"}
            InputLabelProps={{ style: { fontSize: 14, color: "#929191" }, shrink: true }}
          />
        </Grid>
      )}

      {showDiscountFields && (
        <>
          <Grid item xs={12} sm={6}>
            <FormikRemoteAutocompleteField
              name={"museum_exhibition_type_id"}
              label={"Museum Exhibition Type"}
              loadOptions={loadExhibitionTypes}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormikRemoteAutocompleteField
              name={"ticket_fee_id"}
              label={"Ticket Fee"}
              loadOptions={loadTicketTypes}
              getOptionLabel={(o) => o?.name || o?.code || ""}
            />
          </Grid>
          {/* Removed Ticket Fee field since ticket_fees is no longer in master data */}
          <Grid item xs={12} sm={6}>
            <Field
              component={TextField}
              variant={"outlined"}
              size={"small"}
              fullWidth
              label={"From Date (YYYY-MM-DD)"}
              name={"from_date"}
              type={"date"}
              InputLabelProps={{ style: { fontSize: 14, color: "#929191" }, shrink: true }}
              inputProps={{ 
                style: { fontSize: 14 },
                min: "1900-01-01",
                max: "2100-12-31"
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              component={TextField}
              variant={"outlined"}
              size={"small"}
              fullWidth
              label={"To Date (YYYY-MM-DD)"}
              name={"to_date"}
              type={"date"}
              InputLabelProps={{ style: { fontSize: 14, color: "#929191" }, shrink: true }}
              inputProps={{ 
                style: { fontSize: 14 },
                min: "1900-01-01",
                max: "2100-12-31"
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              component={TextField}
              variant={"outlined"}
              size={"small"}
              fullWidth
              label={"Discount Rate"}
              name={"discount_rate"}
              type={"number"}
              InputLabelProps={{ style: { fontSize: 14, color: "#929191" }, shrink: true }}
            />
          </Grid>
        </>
      )}
    </>
  );
}
